<div style="width: 100%;">
  <form [formGroup]="editInitialDescriptionForm">
    <h2 matDialogTitle>Edit initial description</h2>
    <mat-dialog-content>
      <mat-form-field hintLabel="Max 5000 characters" class="input-group">
        <textarea [maxLength]="5000" matInput formControlName="pct_initialdescription" style="height: 500px;"
          (keydown)="onTextareaKeydown($event)" [disabled]="isLoading"></textarea>
      </mat-form-field>


    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-flat-button (click)="onCancel()" [disabled]="isLoading">Cancel</button>
      <button mat-raised-button color="primary" (click)="onUpdateInitialDescription()" [disabled]="isLoading">Save</button>
    </mat-dialog-actions>
  </form>
</div>